import React from 'react'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

import TABLE_SIZES from './tableSizeProps'
import Divider from '~/components/traffic-tickets/steps/Divider'
import EvidenceRowButton from './EvidenceRowButton'

const InfoText = styled.p`
  font-size: 1rem;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props => props.theme.colors.text.header};
`

const PriceText = styled.p`
  font-size: 1rem;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props => props.theme.colors.success};
`

const TextContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
`

const TicketDetailRow = props => {
    return (
      <>
        <Row>
          <Col {...TABLE_SIZES.ticketID}>
            <TextContainer>
              <InfoText>{props.ticket.ticketID}</InfoText>
            </TextContainer>
          </Col>
          <Col {...TABLE_SIZES.issuedOn}>
            <TextContainer>
              <InfoText>{props.ticket.issuedOn}</InfoText>
            </TextContainer>
          </Col>
          <Col {...TABLE_SIZES.amountDue}>
            <TextContainer>
              <PriceText>
                {`$${props.ticket.amountDue}`}
              </PriceText>
            </TextContainer>
          </Col>
          <Col {...TABLE_SIZES.evidence}>
            <TextContainer>
              <EvidenceRowButton ticket={props.ticket} />
            </TextContainer>
          </Col>
        </Row>
        <Divider top={10} bottom={10} />
      </>
    )
}

export default TicketDetailRow